import { CakeIcon, CalendarDaysIcon, ClipboardIcon, PencilSquareIcon, StarIcon } from "@heroicons/react/20/solid";
import { format, intervalToDuration, parse, setHours, setMilliseconds, setMinutes, setSeconds } from "date-fns";
import React from "react";
import { connect } from "react-redux";
import Tooltip from "@/tooltip";
import { Actions } from "../../../store/actions/employeeActions";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

const ChildRow = ({
    child,
    isLast,
    openChildModal,
    isAdmin,
    toggleChildLeaveModal,
    jurisdiction
}) => {
    const { id, reference, dateOfBirth, expectedDate, deceasedDate, deceased: isDeceased } = { ...child }
    const today = setHours(setMinutes(setSeconds(setMilliseconds(new Date(), 0), 0), 0), 0)
    const passingDate = isDeceased ? parse(deceasedDate, 'yyyy-MM-dd', today) : false
    const referenceBirth = parse(dateOfBirth ? dateOfBirth : expectedDate, 'yyyy-MM-dd', today)
    const mmdd = format(today, 'MM-dd')
    const isBirthday = format(referenceBirth, 'MM-dd') === mmdd
    const isMemorial = passingDate ? format(passingDate, 'MM-dd') == mmdd : false
    const { years: age } = { ...(intervalToDuration({ start: referenceBirth, end: passingDate || today })) }
    return (
        <div
            key={`child${id}`}
            style={{ display: "grid", gridGap: "1.5rem", grid: "1.5rem", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", padding: '1rem', borderBottom: isLast ? undefined : 'solid rgb(244,244,244) 4px' }}>
            <div style={{ gridColumn: "span 1 / span 4", textAlign: 'center' }}>
                <h5>{reference}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 4", textAlign: 'center' }}>
                <h5>{referenceBirth ? format(referenceBirth, 'dd MMM yyyy') : null}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 4", textAlign: 'center' }}>
                <h5>{age > 0 ? age : 0}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 4", textAlign: 'center', paddingRight: '4rem' }}>
                <button
                    type="button"
                    onClick={() => openChildModal(child)}
                    className='btn btn-xs btn-default pull-right'
                    style={{ marginLeft: 5 }}>
                    <Tooltip content={`Edit ${reference}`}>
                        <PencilSquareIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                    </Tooltip>
                </button>
                <div
                    type="button"
                    disabled={["MT"].includes(jurisdiction)}
                    onClick={() => {
                        if (["MT"].includes(jurisdiction)) return
                        toggleChildLeaveModal(child)
                    }
                    }
                    className='btn btn-xs btn-success pull-right'
                    style={{ marginLeft: 5 }}>
                    <Tooltip content={["MT"].includes(jurisdiction) ? `Child Related Leave Coming Soon...` : `Apply for Child Related Leave`}>
                        <CalendarDaysIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                    </Tooltip>

                </div>
                {isAdmin ?
                    <div
                        onClick={() => copyToClipboard(id)}
                        className='btn btn-xs btn-default pull-right'
                        style={{ marginLeft: 5 }}>
                        <Tooltip content={`Copy ID`}>
                            <ClipboardIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                        </Tooltip>
                    </div>
                    : null}
                {isBirthday && !isDeceased ?
                    <div
                        className='btn btn-xs btn-primary pull-right'
                        style={{ marginLeft: 5 }}>
                        <Tooltip content={`${reference} has their Birthday today!`}>
                            <CakeIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                        </Tooltip>
                    </div>
                    : null}
                {isDeceased && isMemorial ?
                    <div
                        className='btn btn-xs btn-default pull-right'
                        style={{ marginLeft: 5 }}>
                        <Tooltip content={`${reference} has their memorial day`}>
                            <StarIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                        </Tooltip>
                    </div>
                    : null}
            </div>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        isAdmin: state?.my?.profile?.isAdmin,
        jurisdiction: state.company?.settings?.jurisdiction
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    openChildModal: (child) => dispatch(Actions.toggleChildrenModal({ open: true, child })),
    toggleChildLeaveModal: (child) => dispatch(Actions.toggleChildLeaveModal({ open: true, child, newEntry: true })),

});

export default connect(mapStateToProps, mapDispatchToProps)(ChildRow);
